<template>
    <div class="compDetails">
        <ul>
            <li class="li-title">
                <img :src="require('@/assets/images/tusu.png')" width="24" alt="">
                投诉原因：{{routeObj.reason}}
            </li>
            <li>
                <div><van-icon name="phone-o" size="24" color="#000"/>联系电话</div>
                <input type="number" placeholder="请输入您的联系电话" v-model.trim="form.phone" length="11">
            </li>
            <li >
                <div><van-icon name="comment-o" size="24" color="#ed6a0c" />投诉说明</div>
                <textarea v-model.trim="form.description" placeholder="描述具体内容，有助于客服更快处理"></textarea>
            </li>
            <li class="submit">
                <button class="btn"  @click="handleSubmit">提交投诉</button>
            </li>
        </ul>
        
        <!-- <p>如需要帮助，请联系<i><van-icon name="service-o" />在线客服</i></p> -->
    </div>
</template>
<script>
import {sendComplaint} from '@/api/api'
export default {
    data() {
        return {
            routeObj: {},
            queryList: [
                {name: '充值未到账', icon: require('@/assets/images/daozhang.png')},
                {name: '充错账号', icon: require('@/assets/images/error_3.png')},
                {name: '遭遇诈骗', icon: require('@/assets/images/zhap.png')},
                {name: '其他原因', icon: require('@/assets/images/msg.png')},
            ],
            form: {
                phone: '',
                description: ''
            },
            disabled: false,
        }
    },
    created() {
        this.routeObj = this.$route.query;
    },
    methods: {
        handleSubmit() {
            this.disabled = true;
            if(!this.form.phone) {
                this.$toastTips('请输入您的联系电话！');
                return;
            }
            const {orderNo, reason} = this.routeObj;
            const params = {
                ...this.form,
                orderNo,
                reason,
            };

            console.log(params);
            sendComplaint(params).then(res => {
                this.disabled = false;
                if(res.code === 200) {
                    this.$toast.success('投诉成功，请等待客服联系。');
                } else {
                    this.$toastTips(res?.msg);
                }
                
            });

        }
    }
}
</script>
<style lang="less" scoped>
    .compDetails {
        padding: 15px;
        color: #000;
        font-size: 16px;
        ul {
            background: #fff;
            border-radius: 6px;
            padding: 30px 15px;
            box-shadow: 0 0 8px #ebedf0;
            .li-title {
                justify-content: left;
                img {
                    vertical-align: middle;
                }
            }
            li {
                background: #f8f8f8;
                border-radius: 8px;
                margin-bottom: 15px;
                padding: 15px;
                div {
                    display: flex;
                    align-items: center;
                    gap: 3px;
                }
                input, textarea {
                    margin-top: 10px;
                    width: 100%;
                    outline: none;
                    border: 1px solid #ddd;
                    border-radius: 6px;
                    padding: 10px 15px;
                    height: 40px;
                }
                textarea {
                    max-width: 100%;
                    height: 100px;
                }
            }
            li:last-child {
                margin-bottom: 0;
            }
            .submit {
                background: none;    
                padding: 15px 0;   
                .btn {
                    background: #ed6a0c;
                    height: 45px;
                    line-height: 45px;
                    border-radius: 6px;
                    text-align: center;
                    color: #fff;
                    font-size: 18px;
                    outline: none;
                    display: block;
                    width: 100%;
                    border: none;
                } 
                .btn:active {
                    opacity: .8;
                }
            }
        }
        p {
            margin: 10px 0;
            text-align: center;
            i {
                color: #e0620d;
            }
        }
    }
</style>